import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Alert } from "@mui/material";
import { Delete, Edit, EventNote } from '@mui/icons-material'
import { useDispatch, useSelector } from "react-redux";
import { modalConfirm, modalEdit } from "../../features/modal/modalSlice";
import { useNavigate } from "react-router-dom";
import { searchStudent } from "../../features/students/studentsSlice";

export default function Content(){
    const { backup } = useSelector(state => state.students);
    const dispatch = useDispatch();
    const genders = { H: 'Hombre', M: 'Mujer' }
    const navigate = useNavigate();
    const headers = ['Código','Nombre', 'Estatus', 'Sexo', 'Etnia', 'Calendario', 'Sede', '','',''];
    let len = backup.length;
    if(!len) return;
    return(
        <TableContainer sx={{ mt: '1em' }}>
            <Alert severity="success">Total: <b>{len}</b></Alert>
            <Table>
                <TableHead>
                    <TableRow>
                        { headers.map((h, i) => <TableCell key={i}>{h}</TableCell>) }
                    </TableRow>
                </TableHead>
                <TableBody> 
                    { backup.map(({ id, codigo, nombre, estatus, genero, etnia, calendario, sede }, i) => (
                        <TableRow key={i}>
                            <TableCell><b>{codigo}</b></TableCell>
                            <TableCell>{nombre}</TableCell>
                            <TableCell>{estatus}</TableCell>
                            <TableCell>{genders[genero]}</TableCell>
                            <TableCell>{etnia ? 'Indigena' : null}</TableCell>
                            <TableCell>{calendario}</TableCell>
                            <TableCell>{sede}</TableCell>
                            <TableCell>
                                <IconButton onClick={() => dispatch(searchStudent({ id, navigate: navigate }))} color="info">
                                    <EventNote />
                                </IconButton>
                            </TableCell>
                            <TableCell>
                                <IconButton onClick={() => dispatch(modalEdit(id))} color="primary">
                                    <Edit />
                                </IconButton>
                            </TableCell>
                            <TableCell>
                                <IconButton onClick={() => dispatch(modalConfirm({ id, item: nombre }))} color="secondary">
                                    <Delete />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    )) }
                </TableBody>
            </Table>
        </TableContainer>
    )
}